import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                id: null,
                avatar: null,
                cover: null,
                name: null,
                about: null,
                birthday_at: null,
                city: null,
                education: [],
                achievements: [],
                relationship: null,
                work: null,
                contacts: [],
                links: [],
                credo: null,
                gallery: [],
                access_by_password: false,
                access_password: null,
                published: false,
                indexing: false,
                moments: [],
                stories: [],
                link: '',
                tags: [],
                user_id: null
            },
            defaultValues: {
                education: [
                    {
                        placeholder: Vue.prototype.$lang('profile.education.placeholder1'),
                        value: '',
                        year: ''
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.education.placeholder2'),
                        value: '',
                        year: ''
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.education.placeholder3'),
                        value: '',
                        year: ''
                    }
                ],
                achievements: [
                    {
                        placeholder: Vue.prototype.$lang('profile.achievements.placeholder1'),
                        value: '',
                        year: ''
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.achievements.placeholder2'),
                        value: '',
                        year: ''
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.achievements.placeholder3'),
                        value: '',
                        year: ''
                    }
                ],
                contacts: [
                    {
                        placeholder: Vue.prototype.$lang('profile.contacts.placeholder1'),
                        value: ''
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.contacts.placeholder2'),
                        value: ''
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.contacts.placeholder3'),
                        value: ''
                    }
                ],
                links: [
                    {
                        placeholder: Vue.prototype.$lang('profile.links.placeholder1'),
                        value: '',
                        icon: 'icon-inst.svg'
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.links.placeholder2'),
                        value: '',
                        icon: 'icon-vk.svg'
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.links.placeholder3'),
                        value: '',
                        icon: 'icon-fb.svg'
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.links.placeholder4'),
                        value: '',
                        icon: 'icon-telegram.svg'
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.links.placeholder5'),
                        value: '',
                        icon: 'icon-wa.svg'
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.links.placeholder6'),
                        value: '',
                        icon: 'icon-twitter.svg'
                    },
                    {
                        placeholder: Vue.prototype.$lang('profile.links.placeholder7'),
                        value: '',
                        icon: 'icon-ok.svg'
                    },
                ],
                gallery: [
                    {
                        nameAlbum: '',
                        photos: [],
                        uuid: 1
                    }
                ],
                stories: [
                    {
                        title: '',
                        description: ''
                    }
                ],
                moments: [
                    {
                        title: '',
                        description: '',
                        date: null,
                        photo: null,
                    }
                ],
                tags: []
            }
        }
    },
    getters: {
        form: (state) => state.form,
        defaultValues: (state) => state.defaultValues,
        moments: (state) => state.form.moments,
        stories: (state) => state.form.stories,
        tags: (state) => state.form.tags,
    },
    mutations: {
        setForm(state, value) {
            window.Vue.set(state, 'form', value);
        },
        setGallery(state, value) {
            window.Vue.set(state.form, 'gallery', value);
        },
        pushMoment(state, value) {
            value.isCreated = true;

            state.form.moments.push(value);
        },
        removeMoment(state, index) {
            state.form.moments.splice(index, 1);
        },
        updateMoment(state, {value, index}) {
            window.Vue.set(state.form.moments, index, value);
        },
        pushTag(state, value) {
            state.form.tags.push(value);
        },
        setAccessByPasswordMoment(state, {value, index}) {
            window.Vue.set(state.form.moments[index], 'access_by_password', value);
        },
        setAccessPasswordMoment(state, {value, index}) {
            window.Vue.set(state.form.moments[index], 'access_password', value);
        },
        setAccessByPassword(state, value) {
            window.Vue.set(state.form, 'access_by_password', value);
        },
        setAccessPassword(state, value) {
            window.Vue.set(state.form, 'access_password', value);
        },
        setUserId(state, value) {
            window.Vue.set(state.form, 'user_id', value);
        },
        clearEmptyInputs(state) {
            let arrays = ['education', 'achievements', 'contacts', 'links', 'gallery', 'stories', 'moments'];

            arrays.forEach((value) => {
                let defaultLength = state.defaultValues[value].length;
                let obj = state.form[value];

                switch(value) {
                    case 'gallery':
                        Object.keys(obj).forEach((i) => obj[i].nameAlbum === '' && !obj[i].photos.length && i >= defaultLength && delete obj[i]);
                        break;
                    case 'stories':
                    case 'moments':
                        Object.keys(obj).forEach((i) => obj[i].title === '' && obj[i].description === '' && i >= defaultLength && delete obj[i]);
                        break;
                    default:
                        Object.keys(obj).forEach((i) => obj[i].value === '' && i >= defaultLength && delete obj[i]);
                }

                state.form[value] = Object.assign([], obj.filter(x => x !== null));
            });
        },
    },
    actions: {
        getTags({}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.get('/moments/tags', payload)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        searchMoment({}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.post('/moments', payload)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getProfile({state}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get('/profile/' + id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        createProfile({state}, form) {
            return new Promise((resolve, reject) => {
                ApiService.post('/profile', form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        updateProfile({state}, form) {
            return new Promise((resolve, reject) => {
                ApiService.update('/profile/' + form.id, form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getProfileByUserId({state}, userId) {
            return new Promise((resolve, reject) => {
                ApiService.get('/profile/user/' + userId)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
    }
}
